module.exports = __webpack_public_path__ + "static/img/IT22.a72604c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/IT22.jpg
// module id = wgn2
// module chunks = 0